import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';

interface CreateNewReportProps {
  to?: string;
}

export const CreateNewReport = ({ to = '/analytics' }: CreateNewReportProps) => (
  <div className='px-8 xl:px-12 w-1/4 mb-16 xl:mb-30 min-h-[120px] xl:min-h-[8.4375rem]'>
    <Link
      to={to}
      className='shadow-[0px_4px_7px_0px_rgba(102,102,102,0.05),0px_3px_0px_0px_#DFDFDF] rounded-8 flex items-center justify-center bg-neutral-10 border border-neutral-20 transition-all duration-300 hover:bg-grey-50 h-full'
    >
      <div className='flex flex-col items-center justify-center text-neutral-50'>
        <div className='mb-2'>
          <AddIcon className='text-neutral-50' sx={{ fontSize: 40 }} />
        </div>
        <p className='xl:text-18 text-16 mb-2'>Start New</p>
        <p className='xl:text-14 text-12 mb-2'>(no filters applied)</p>
      </div>
    </Link>
  </div>
);
